import React, { useRef } from 'react';

import { Button, Checkbox, Container, FormControlLabel, Grid, makeStyles, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

import ChangePassword from '../../models/PasswordReset';
import EditFields from '../common/EditFields';
import Footer from '../footer/Footer';
import LoginHeader from '../login/LoginHeader';

const useStyles = makeStyles((theme) => {
  return {
    buttonContainer: {
      marginTop: '1rem',
      position: 'relative',
      [theme.breakpoints.up('md')]: {
        marginTop: '100px',
      },
    },
    checkboxContainer: {
      marginTop: '16px',
    },
    checkboxesMainContainer: {
      [theme.breakpoints.up('md')]: {
        maxWidth: 'none',
        position: 'absolute',
        top: '0px',
        width: '524px',
      },
    },
    formTitle: {
      color: '#172B4D',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    link: {
      color: theme.palette.primary.main,
    },
    loginHint: {
      color: 'rgba(0, 0, 0, 0.38)',
      fontSize: '14px',
      lineHeight: 1.8,
      marginBottom: '0rem',
    },
    loginLabels: {
      fontWeight: 'bold',
    },
    logo: {
      display: 'flex',
      marginBottom: '3rem',
      textAlign: 'unset',
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      maxWidth: '368px',
      padding: '24px',
    },
    parentContainer: {
      display: 'grid',
      minHeight: '100vh',
    },
    passwordLink: {
      fontSize: '14px',
      marginBottom: '1rem',
    },
    textDash: {
      width: '100%',
    },
    typographyLabel: {
      color: '#999999',
      fontSize: '11px',
      lineHeight: '16px',
      transform: 'translateY(2px)',
    },
    typographyWarning: {
      color: '#dd5555',
      fontSize: '12px',
      fontWeight: '500',
      lineHeight: '16px',
      marginTop: '12px',
      textAlign: 'left',
    },
  };
});

const fields = [
  { hidePasswordIcon: true, label: 'Password', labelPosition: 'top', name: 'newPassword', placeholder: '***********', type: 'password' },
  { hidePasswordIcon: true, label: 'Re-enter Password', labelPosition: 'top', name: 'repeatPassword', placeholder: '***********', type: 'password' },
];
const defaultData = { newPassword: '', repeatPassword: '' };

export default ({ onSubmit, isInvite, termsCheck, onTermsCheckChange, buttonError }) => {
  const classes = useStyles();
  const editFieldRef = useRef();

  // Enter key pressed
  const handleSave = (data) => {
    onSubmit(data);
  };

  // Click submit button
  const handleSubmit = async () => {
    const validData = await editFieldRef.current.getValidData();

    if (validData) {
      onSubmit(validData);
    }
  };

  const handleTermsCheckChange = (target, e) => {
    if (onTermsCheckChange) onTermsCheckChange(target, e.target.checked);
  };

  return (
    <div className={classes.parentContainer}>
      <div style={{ marginBottom: 'auto' }}>
        <LoginHeader />
      </div>

      <div className={{ margin: 'auto' }}>
        <Container component="main" className={classes.mainContainer}>
          <Container component="div" disableGutters>
            <Typography variant="h4" className={classes.formTitle} align="center">
              {isInvite ? 'Create Password' : 'Reset Password'}
            </Typography>
          </Container>

          <form style={{ position: 'relative' }}>
            <Grid container direction="column" justify="flex-end">
              <Grid item>
                <EditFields
                  data={defaultData}
                  fields={fields}
                  onSave={handleSave}
                  validate={ChangePassword.validateCreate}
                  useLabel
                  allowEnterSubmit
                  ref={editFieldRef}
                  labelPosition="top"
                  labelClass={classes.loginLabels}
                />
              </Grid>

              <Grid item>
                <Typography variant="body1" className={classes.loginHint} align="left">
                  Note that your password needs to contain at least one capital letter and one numeric character.
                </Typography>
              </Grid>

              {isInvite ? (
                <div style={{ position: 'relative' }}>
                  <Grid className={classes.checkboxesMainContainer} item container xs={12}>
                    <div className={classes.checkboxContainer}>
                      <FormControlLabel
                        classes={{ root: 'mediphany-formcontrol-root' }}
                        control={
                          <Checkbox
                            classes={{ root: 'mediphany-checkbox-root' }}
                            value={termsCheck}
                            onChange={(e) => handleTermsCheckChange('terms', e)}
                            name="checkedB"
                            size="small"
                            color="primary"
                          />
                        }
                        label={
                          <Typography className={`${classes.typographyLabel} text-left`}>
                            I have read, understand and agree to Mediphany’s&nbsp;
                            <a href="https://mediphany.com/terms-and-conditions/" className={classes.link} target="_blank" rel="noreferrer">
                              Terms of Service
                            </a>
                            &nbsp;and&nbsp;
                            <a href="https://mediphany.com/privacy-policy/" className={classes.link} target="_blank" rel="noreferrer">
                              Privacy Policy
                            </a>
                            .
                          </Typography>
                        }
                      />
                    </div>
                  </Grid>
                </div>
              ) : null}

              <Grid item className={classes.buttonContainer}>
                <Button variant="contained" color="primary" fullWidth onClick={handleSubmit}>
                  {isInvite ? ' Submit' : 'Reset Password'}
                </Button>

                {buttonError ? <Typography className={classes.typographyWarning}>{buttonError}</Typography> : null}
              </Grid>
            </Grid>
          </form>
        </Container>
      </div>

      <div style={{ marginTop: 'auto' }}>
        <Footer />
      </div>
    </div>
  );
};
